export async function NotificacionCreate( 
    notiUser,
    metaFecha,
    notiText,
    notiUrl,
    notiRead ) {
    const formData = {
        status: "publish",
        meta: {
            notiUser: notiUser,
            metaFecha: metaFecha,
            notiText: notiText,
            notiUrl: notiUrl,
            notiRead: notiRead
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/notificacion', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}


export async function NotificacionSchedule(
    notiUser,
    metaFecha,
    notiText,
    notiUrl,
    notiRead,
    scheduledDate
) {
    const formData = {
        status: "future",
        date: scheduledDate,
        meta: {
            notiUser: notiUser,
            metaFecha: metaFecha,
            notiText: notiText,
            notiUrl: notiUrl,
            notiRead: notiRead
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/notificacion', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}

export async function NotificacionCreateWithAuthor( 
    notiUser,
    metaFecha,
    notiText,
    notiUrl,
    notiRead,
    notiAuthor,
    notiMail,
    notiSms
) {
    const formData = {
        status: "publish",
        author: notiAuthor,
        meta: {
            notiUser: notiUser,
            metaFecha: metaFecha,
            notiText: notiText,
            notiUrl: notiUrl,
            notiRead: notiRead,
            notiMail: notiMail,
            notiSms: notiSms
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/notificacion', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}


export async function NotificacionScheduleWithAuthor(
    notiUser,
    metaFecha,
    notiText,
    notiUrl,
    notiRead,
    scheduledDate,
    notiAuthor,
    notiMail,
    notiSms
) {
    const formData = {
        status: "future",
        author: notiAuthor,
        date: scheduledDate,
        meta: {
            notiUser: notiUser,
            metaFecha: metaFecha,
            notiText: notiText,
            notiUrl: notiUrl,
            notiRead: notiRead,
            notiMail: notiMail,
            notiSms: notiSms
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/notificacion', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}